import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { DESKTOP_TOTAL_HEIGHT } from '@constants/common/ui.constants';

const useStyles = makeStyles<{ isOpen: boolean }>()((theme, { isOpen }) => ({
  layout: {
    ...dFlex('initial', 'initial'),
    flexDirection: 'column',
  },
  container: {
    flex: 1,
    position: 'relative',
    height: '100%',
    minHeight: `calc(100vh - ${DESKTOP_TOTAL_HEIGHT}px)`,
  },
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 274px)',
  },
  chat: {
    position: 'fixed',
    right: '64px',
    bottom: '40px',
    height: '56px',
    width: '56px',
    borderRadius: '50%',
    background: theme.gradient.g2,
    cursor: 'pointer',
    ...dFlex('center', 'center'),
    zIndex: '100000',
  },
  frame: {
    position: 'fixed',
    right: '64px',
    bottom: '100px',
    width: '460px',
    height: isOpen ? '650px' : '0px',
    transition: 'height .5s ease-in-out, max-height .5s ease-in-out',
    borderRadius: theme.borderRadius.md,
    border: 'none',
    zIndex: '100000',
  },
}));

export default useStyles;
